import { validateAppointmentStepOneBookingDraft } from "@/app/booking/core/appointmentBookingDraft";
import {
  createAppointmentStepOneDraftFingerprint,
  isAppointmentDraftFingerprint,
} from "@/app/booking/core/appointmentDraftFingerprint";

import { createSpecialistLocationGatewayFingerprint } from "./contract";

export function createSpecialistLocationGatewayAppointmentDestinationFingerprint(
  value: unknown,
) {
  const validation = validateAppointmentStepOneBookingDraft(value);
  if (!validation.valid) return null;
  const sourceFingerprint = createAppointmentStepOneDraftFingerprint(
    validation.draft,
  );
  return sourceFingerprint
    ? createSpecialistLocationGatewayFingerprint([
        "individual-appointment-step-one-v1",
        sourceFingerprint,
      ])
    : null;
}

export function createSpecialistLocationGatewayAppointmentDestinationFingerprintFromStepOneFingerprint(
  value: unknown,
) {
  return isAppointmentDraftFingerprint(value)
    ? createSpecialistLocationGatewayFingerprint([
        "individual-appointment-step-one-v1",
        value,
      ])
    : null;
}
